/**
 * Google Analytics 事件追踪工具
 * 所有追踪操作都包含错误处理，不会影响正常业务逻辑
 */

type GtagEvent = {
  [key: string]: string | number | boolean | undefined;
};

/**
 * 安全地发送 GA4 事件
 */
export const trackEvent = (eventName: string, params?: GtagEvent): void => {
  try {
    if (typeof window !== 'undefined' && (window as any).gtag) {
      (window as any).gtag('event', eventName, params);
    }
  } catch (error) {
    // 静默失败，不影响业务逻辑
    console.debug('[Analytics] Track event failed:', error);
  }
};

/**
 * 追踪用户登录
 */
export const trackLogin = (address: string, inviteCode?: string): void => {
  trackEvent('login', {
    method: 'wallet',
    user_id: address.toLowerCase(),
    invite_code: inviteCode || 'none',
  });
};

/**
 * 追踪游戏开始
 */
export const trackGameStart = (gameId: string, gameTitle: string, address?: string): void => {
  trackEvent('game_start', {
    game_id: gameId,
    game_title: gameTitle,
    user_id: address?.toLowerCase() || 'anonymous',
  });
};
